export const ROW = 'Row';
export const TEXTBOX = 'TextBox';
export const VERTICALSPACER = 'VerticalSpacer';
export const STANDARDPRODUCTTABLE = 'StandardProductTable';
export const ABOUT = 'About';
export const ABTESTWRAPPER = 'ABTestWrapper';
export const ADVERTISERDISCLOSUREWRAPPER = 'AdvertiserDisclosureWrapper';
export const APPROW = 'AppRow';
export const AUDIOEMBED = 'AudioEmbed';
export const ARTICLEHEROWRAPPER = 'ArticleHeroWrapper';
export const AUTOINSURANCEENTRYPOINTWRAPPER = 'AutoInsuranceEntryPointWrapper';
export const AUTOINSURANCEQUOTESWRAPPER = 'AutoInsuranceQuotesWrapper';
export const AWARDSBADGEDROPDOWN = 'AwardsBadgeDropdown';
export const AWARDSBADGEDROPDOWNV2 = 'AwardsBadgeDropdownV2';
export const AWARDSHERO = 'AwardsHero';
export const AWARDSHERO2023 = 'AwardsHero2023';
export const AWARDS2024BUTTONS = 'Awards2024Buttons';
export const AWARDSNAVIGATION = 'AwardsNavigation';
export const BAINREFERRALBANNERSC = 'BainReferralBannerSC';
export const BACKTOTOP = 'BackToTop';
export const AWARDTABLE = 'AwardTable';
export const BOXTABLE = 'BoxTable';
export const BORDERBANNER = 'BorderBanner';
export const BRANDHEADER = 'BrandHeader';
export const BRANDEDARTICLECALCULATOR = 'BrandedArticleCalculator';
export const BRANDEDHERO = 'BrandedHero';
export const BULLETEDLIST = 'BulletedList';
export const C3CHART = 'C3Chart';
export const CALCULATOR = 'Calculator';
export const CATEGORYTILES = 'CategoryTiles';
export const CDSPRODUCTTABLE = 'CdsProductTable';
export const CDSFILTERS = 'CdsFilters';
export const CENTEREDHERO = 'CenteredHero';
export const CHARTSECTION = 'ChartSection';
export const COLLAPSIBLEPARAGRAPH = 'CollapsibleParagraph';
export const CREDITCARDTABLE = 'CreditCardTable';
export const CTABOX = 'CtaBox';
export const DISCLOSURE = 'Disclosure';
export const DIVIDER = 'Divider';
export const EDITABLEBULLETEDLIST = 'EditableBulletedList';
export const EDITABLEFLYOUTHEADER = 'EditableFlyOutHeader';
export const EDITABLEFLOW = 'EditableFlow';
export const EDITABLEINTERESTCALCULATOR = 'EditableInterestCalculator';
export const EDITABLELOGOSALAD = 'EditableLogoSalad';
export const EDITABLEPANELGROUP = 'EditablePanelGroup';
export const EDITABLEPRODUCTTABLE = 'EditableProductTable';
export const EDITORCONTROL = 'EditorControl';
export const EXPANDINGPRODUCTTABLE = 'ExpandingProductTable';
export const FILTERS = 'Filters';
export const FEATUREBAR = 'FeatureBar';
export const FLEXCARD = 'FlexCard';
export const FLEXCARDS = 'FlexCards';
export const FEATUREDSTORY = 'FeaturedStory';
export const GLOBALNAV = 'GlobalNav';
export const GRID = 'Grid';
export const GRIDFORM = 'GridForm';
export const HEROLANDSCAPEVIDEO = 'HeroLandscapeVideo';
export const HEROVIDEO = 'HeroVideo';
export const HOMEINSURANCEENTRYPOINTWRAPPER = 'HomeInsuranceEntryPointWrapper';
export const HORIZONTALBANNER = 'HorizontalBanner';
export const ICONHEADER = 'IconHeader';
export const IMAGE = 'Image';
export const IMAGECONTENT = 'ImageContent';
export const INSURANCEPRODUCTCARDWRAPPER = 'InsuranceProductCardWrapper';
export const INSURANCESTICKYWIDGET = 'InsuranceStickyWidget';
export const INSURANCESUMMARYTABLEWRAPPER = 'InsuranceSummaryTableWrapper';
export const JUMPLINKNAV = 'JumpLinkNav';
export const KETOPRODUCTCARD = 'KetoProductCard';
export const LABELEDC3CHART = 'LabeledC3Chart';
export const LASTCHANCE = 'LastChance';
export const LASTUPDATE = 'LastUpdate';
export const LOTTIEANIMATION = 'LottieAnimation';
export const LIFEINSURANCEQUOTESWRAPPER = 'LifeInsuranceQuotesWrapper';
export const MARKETPLACEPRODUCTCARD = 'MarketplaceProductCard';
export const MARKETPLACETHIRDPARTYEMBED = 'MarketplaceThirdPartyEmbedWrapper';
export const NPSCRMEMAIL = 'NpsCrmEmail';
export const PAGE = 'Page';
export const PARAGRAPH = 'Paragraph';
export const PASSWORDLOCK = 'PasswordLock';
export const QUERYPARAMMANAGER = 'QueryParamManager';
export const QUERYPARAMSECTION = 'QueryParamSection';
export const OURVALUES = 'OurValues';
export const RENTERSINSURANCEENTRYPOINTWRAPPER =
  'RentersInsuranceEntryPointWrapper';
export const ROWTWOCOL = 'RowTwoCol';
export const ROWTWOCOLOLD = 'RowTwoColOld';
export const SCREENSIZECONDITIONAL = 'ScreenSizeConditional';
export const SCROLLCONTROL = 'ScrollControl';
export const SPLASH = 'Splash';
export const STANDARDHERO = 'StandardHero';
export const STICKYCONTAINERWRAPPER = 'StickyContainerWrapper';
export const STICKYHEADER = 'StickyHeader';
export const STICKYHEADERV2 = 'StickyHeaderV2';
export const STORY = 'Story';
export const STORYBLOCK = 'StoryBlock';
export const STORYCARDS = 'StoryCards';
export const SWEEPSTAKESFORM = 'SweepstakesForm';
export const TERMSTABLE = 'TermsTable';
export const THIRDPARTYEMBED = 'ThirdPartyEmbed';
export const THREESTEPS = 'ThreeSteps';
export const THREESTEPS2 = 'ThreeSteps2';
export const TILECAROUSEL = 'TileCarousel';
export const TICKERTAPE = 'TickerTape';
export const UNIVERSALACCORDION = 'UniversalAccordion';
export const UNIVERSALAUTHBUTTON = 'UniversalAuthButton';
export const UNIVERSALBACKGROUNDIMAGE = 'UniversalBackgroundImage';
export const UNIVERSALBUTTON = 'UniversalButton';
export const UNIVERSALCONTAINER = 'UniversalContainer';
export const UNIVERSALIMAGE = 'UniversalImage';
export const UNIVERSALMEDIA = 'UniversalMedia';
export const UNIVERSALPRODUCTTABLE = 'UniversalProductTable';
export const UNIVERSALTEXT = 'UniversalText';
export const VIDEOEMBED = 'VideoEmbed';
export const ZIGZAG = 'ZigZag';
